module.exports = __webpack_public_path__ + "static/media/home_bg1.76ee4fe8.webp";